import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import Header_m from "./Header_m";
import "./styles/App.css";
import "./styles/il.css";
import "./styles/ji.css";
import "./styles/tae.css";
import { useMediaQuery } from "react-responsive";
import CustomerInfo from "./CustomerInfo";
import TestFigma from "./TestFigma";
import { instance } from "./common";
import { connect } from "react-redux";

function getTimeStamp() {
  var d = new Date();
  var s =
    leadingZeros(d.getFullYear(), 4) +
    "-" +
    leadingZeros(d.getMonth() + 1, 2) +
    "-" +
    leadingZeros(d.getDate(), 2) +
    " " +
    leadingZeros(d.getHours(), 2) +
    ":" +
    leadingZeros(d.getMinutes(), 2) +
    ":" +
    leadingZeros(d.getSeconds(), 2);

  return s;
}

function leadingZeros(n, digits) {
  var zero = "";
  n = n.toString();

  if (n.length < digits) {
    for (let i = 0; i < digits - n.length; i++) zero += "0";
  }
  return zero + n;
}

function deviceCheck() {
  // 디바이스 종류 설정
  var pcDevice = "win16|win32|win64|mac|macintel";
  var device = "";
  // 접속한 디바이스 환경
  if (navigator.platform) {
    if (pcDevice.indexOf(navigator.platform.toLowerCase()) < 0) {
      device = "M";
    } else {
      device = "P";
    }
  }
  return device;
}

function isBrowserCheck() {
  const agt = navigator.userAgent.toLowerCase();
  if (agt.indexOf("chrome") != -1) return "Chrome";
  if (agt.indexOf("opera") != -1) return "Opera";
  if (agt.indexOf("staroffice") != -1) return "Star Office";
  if (agt.indexOf("webtv") != -1) return "WebTV";
  if (agt.indexOf("beonex") != -1) return "Beonex";
  if (agt.indexOf("chimera") != -1) return "Chimera";
  if (agt.indexOf("netpositive") != -1) return "NetPositive";
  if (agt.indexOf("phoenix") != -1) return "Phoenix";
  if (agt.indexOf("firefox") != -1) return "Firefox";
  if (agt.indexOf("safari") != -1) return "Safari";
  if (agt.indexOf("skipstone") != -1) return "SkipStone";
  if (agt.indexOf("netscape") != -1) return "Netscape";
  if (agt.indexOf("mozilla/5.0") != -1) return "Mozilla";
  if (agt.indexOf("msie") != -1) {
    let rv = -1;
    if (navigator.appName == "Microsoft Internet Explorer") {
      let ua = navigator.userAgent;
      var re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
      if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
    }
    return "Internet Explorer " + rv;
  }
}

function refererCheck() {
  let ref = document.referrer;
  if (!ref) {
    ref = "direct";
  }
  return ref;
}

function App(props) {
  console.log("props : ", props.state);
  const isPc = useMediaQuery({
    query: "(min-width:768px)",
  });
  const isMobile = useMediaQuery({
    query: "(max-width:767px)",
  });

  useEffect(() => {
    instance.post("/log/ip").then(function (res) {
      let obj = {
        pv_ip: res.data,
        pv_page: props.state,
        pv_date: getTimeStamp(),
      };
      instance.post("/log/pv", { obj: obj }).then(function (res) {});
    });
  }, [props.state]);

  useEffect(() => {
    instance.post("/log/ip").then(function (res) {
      let obj = {
        uv_ip: res.data,
        uv_date: getTimeStamp(),
        uv_device: deviceCheck(),
        uv_browser: isBrowserCheck(),
        uv_referer: refererCheck(),
      };
      instance.post("/log/uv", { obj: obj }).then(function (res) {});
    });
  }, []);

  // document.getElementById('root').addEventListener('click', function(event){
  //   setNowPage(window.location.href)
  // });

  // console.log('-------user view----')
  // console.log('uv_ip : ', res.data);
  // console.log('uv_page : ', window.location.href)
  // console.log('uv_date : ', getTimeStamp())
  // console.log('uv_device : ', deviceCheck());
  // console.log('uv_browser : ', isBrowserCheck());
  // console.log('uv_referer : ', refererCheck());
  return (
    <>
      {isPc && (
        <>
          <Header />
          <Footer />
        </>
      )}
      {isMobile && (
        <>
          <Header_m />
        </>
      )}
      {/* <CustomerInfo /> */}
    </>
  );
}

function storeLoad(state) {
  return {
    state: state,
  };
}

export default connect(storeLoad)(App);
